import { reports } from "./reports";
import { tableColumnTypes } from "../../tableColumnTypes";
import { FormattedMessage } from "react-intl";

export const quizModalReport = {
  label: "Quiz Report",
  path: `${reports.path}/quizReport`,

  columns: (navigate, handleQuizPopUp) => [
    {
      ID: 1,
      name: <FormattedMessage id="NO" />,
      fieldName: "ClassNames",
      value: (row, index) => index + 1,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="QUESTION" />,
      fieldName: "QuestionText",
      value: (row) => (
        <span
          style={{
            textDecoration: "underline",
            color: "#0051BC",
            cursor: "pointer",
          }}
          onClick={() => handleQuizPopUp(row.QuestionID)}
        >
          {row.QuestionText}
        </span>
      ),
      sort: true,
      type: tableColumnTypes.NUMBER,
    },
    {
      ID: 3,
      name: <FormattedMessage id="CORRECT_RESPONSE" />,
      fieldName: "PercentCorrectResponse",
      value: (row) => row.PercentCorrectResponse,
      sort: true,
      type: tableColumnTypes.NUMBER,
    },
  ],
};

// handleQuizPopUp(row.QuestionID);
